/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import '../../../../App.css'
import {useNavigate} from 'react-router-dom'
import useLocalStorageFetch from '../../../../hooks/localStorageFetch'
import {LoadingSpinner} from '../../../layout/components/LoadingSpinner'
import useApi from '../../../../hooks/useQuery'
import {
  CANCEL_APPOINTMENT,
  GET_DOCTOR_APPOINTMENT_ON_DATE,
} from '../../../../app/MasterModules/DoctorModule/GraphQLQueries/Dashboard'
import moment from 'moment'
import {checkPermission} from '../../../../app/App'
import clsx from 'clsx'
import {KTSVG} from '../../../helpers'
import {useGetDateTimeFormat} from '../../../../data/config'
import useMutationApi from '../../../../hooks/useMutation'
import {toast} from 'react-toastify'
import {success} from '../../../../data/Status/success'
import {ToastMessageContainer} from '../../../layout/components/ToastMessageContainer'
import {Modal} from 'react-bootstrap'
import {AppointmentListTable} from '../../../../app/MasterModules/DoctorModule/modules/todayAppointment/table-list/table/AppointmentListingTable'

const AppoitmentsList = () => {
  // const navigate = useNavigate()
  // const {role} = useLocalStorageFetch()
  const [listing, setList] = useState([])
  // const [mainTabs, setMainTabs] = useState('pending')
  // const [isLoading, setLoading] = useState(false)
  // const [modalState, setmodalState] = useState(false)
  // const [appointmentData, setAppointmentData] = useState<object | null>({})
  const [pageNumber, setpageNumber] = useState(1)
  // const [limit, setlimit] = useState(10)
  const [totalPages, settotalPages] = useState(1)
  // const getTimeZone = () => {
  //   return Intl.DateTimeFormat().resolvedOptions().timeZone
  // }

  // const {
  //   data,
  //   loading,
  //   error,
  //   refetch: refectchappointments,
  // } = useApi(true, GET_DOCTOR_APPOINTMENT_ON_DATE, {
  //   date: moment().format('YYYY-MM-DD'),
  //   timeZone: getTimeZone(),
  //   page: pageNumber,
  //   limit: limit,
  // })

  // const handleRefetch = () => {
  //   refectchappointments({
  //     date: moment().format('YYYY-MM-DD'),
  //     timeZone: getTimeZone(),
  //     page: pageNumber,
  //     limit: limit,
  //   })
  // }

  // const onHandleclick = (appointment: any) => {
  //   navigate(`/${role}/rx_template/rx-on-fly`, {
  //     state: {
  //       appointmentId: appointment.id,
  //       patientData: {
  //         userId: appointment.patientId,
  //         firstName: appointment.firstName,
  //         lastName: appointment.lastName,
  //       },
  //     },
  //   })
  // }

  // const {
  //   createData,
  //   loading: cancelAppointmentLoading,
  //   error: cancelAppointmenterror,
  //   data: cancelAppointmentData,
  // } = useMutationApi(CANCEL_APPOINTMENT)

  // const onHandleCancelAppointment = async (appointment: any) => {
  //   try {
  //     setLoading(true)
  //     await createData({
  //       appointmentId: appointment.id,
  //       status: 'Cancelled',
  //     })
  //     toast.success(success.APPOINTMENT_CANCELED_SUCCESSFULLY)
  //     refectchappointments({date: moment().format('YYYY-MM-DD'), timeZone: getTimeZone()})
  //     setmodalState(false)
  //     // setTimeout(() => {
  //     //   setLoading(false)
  //     //   navigate(`/${role}/dashboard`)
  //     // }, 2000)
  //   } catch (error) {
  //     setLoading(false)
  //   }
  // }

  // useEffect(() => {
  //   if (data) {
  //     const res = data?.getDoctorAppointmentOnDateV2?.data
  //     let filterRes = []
  //     if (mainTabs === 'pending') {
  //       filterRes = res.filter((item: any) => item?.latestStatus === 'Confirmed')
  //     } else {
  //       filterRes = res.filter((item: any) => item?.latestStatus === 'Completed')
  //     }
  //     setList(filterRes)
  //     settotalPages(data?.getDoctorAppointmentOnDateV2?.totalPages)
  //     setpageNumber(data?.getDoctorAppointmentOnDateV2?.page)
  //   }
  // }, [data, mainTabs, loading])

  return (
    <div className='card card-xl-stretch'>
      {/* {modalState && (
        <div>
          <ToastMessageContainer />
          <Modal
            show={modalState}
            dialogClassName='ePulse-modal ePulse-modal-50w'
            onHide={() => setmodalState(false)}
            backdrop='static'
          >
            <Modal.Header closeButton>
              <span className='fs-3 fw-bold'>Cancel Appointment</span>
            </Modal.Header>
            <Modal.Body className='container'></Modal.Body>
            <div className='ePulse-modal-content'>
              <LoadingSpinner isLoading={loading} />
              <div className='bg-white rounded p-3 '>
                <span>Are you sure you want to cancel appointment?</span>
              </div>

              <div className='btn-row'>
                <button
                  className='ePulse-btn-primary'
                  type='button'
                  onClick={() => onHandleCancelAppointment(appointmentData)}
                >
                  Yes
                </button>
                <button
                  className='ePulse-btn-secondory ms-2'
                  type='button'
                  onClick={() => setmodalState(false)}
                >
                  No
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}

      <LoadingSpinner isLoading={loading || cancelAppointmentLoading} /> */}
      {/* begin::Header */}

      {/* <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>
            Today's Appointments
            <span className='fw-normal fs-5'>({useGetDateTimeFormat(new Date())})</span>
          </span>
        </h3>
        <div className='filter-row-notification'>
          <button
            // className={
            //   mainTabs === 'pending'
            //     ? clsx('ePulse-btn-secondory me-4')
            //     : 'ePulse-btn-selected-white text-dark me-4'
            // }

            className='rx-on-fly-button me-3 border border-1 border-light rounded '
            onClick={() => {
              refectchappointments({
                date: moment().format('YYYY-MM-DD'),
                timeZone: getTimeZone(),
              })
            }}
          >
            <img
              alt='refresh'
              style={{width: 15, height: 15, cursor: 'pointer'}}
              src={'/media/ePulse/icons/refresh_white.png'}
            />
          </button>

          <button
            className={
              mainTabs === 'pending'
                ? clsx('ePulse-btn-secondory me-4')
                : 'ePulse-btn-selected-white text-dark me-4'
            }
            onClick={() => {
              setMainTabs('pending')
              refectchappointments({
                date: moment().format('YYYY-MM-DD'),
                timeZone: getTimeZone(),
              })
              // handleRefetchPending()
            }}
          >
            <span className='fs-6 '>Pending</span>
          </button>
          <button
            className={
              mainTabs === 'completed'
                ? clsx('ePulse-btn-secondory')
                : 'ePulse-btn-selected-white text-dark'
            }
            onClick={() => {
              setMainTabs('completed')
              refectchappointments({
                date: moment().format('YYYY-MM-DD'),
                timeZone: getTimeZone(),
              })
              // handleRefetchCompleted()
            }}
          >
            <span className='fs-6 '>Completed</span>
          </button>
        </div>
      </div> */}

      <div
        className='card-body pt-5'
        //  style={{height: '400px', overflow: 'scroll'}}
      >
        <AppointmentListTable />
      </div>
    </div>
  )
}

export {AppoitmentsList}
